;(function() {
  'use strict'

  angular.module('core.noPropagate', [])
})()
